var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0478 19.25L8.0478 19.25L8.04072 19.25C8.00326 19.2502 7.96616 19.2429 7.93157 19.2285C7.89697 19.2142 7.8656 19.193 7.83929 19.1664L7.8393 19.1664L7.83633 19.1634C7.78105 19.1081 7.75 19.033 7.75 18.9548C7.75 18.8766 7.781 18.8017 7.8362 18.7463C7.83624 18.7463 7.83628 18.7463 7.83633 18.7462L14.0653 12.5173L14.5956 11.987L14.0653 11.4566L7.84822 5.23959C7.8 5.18451 7.7739 5.11337 7.7752 5.03997C7.77655 4.9635 7.80752 4.89054 7.86161 4.83646C7.91569 4.78237 7.98865 4.7514 8.06512 4.75005C8.13853 4.74875 8.20966 4.77485 8.26474 4.82306L15.22 11.7784C15.2753 11.8337 15.3064 11.9087 15.3064 11.987C15.3064 12.0652 15.2753 12.1402 15.22 12.1956L8.25252 19.1631L8.25251 19.1631L8.24923 19.1664C8.22292 19.193 8.19154 19.2142 8.15695 19.2285C8.12236 19.2429 8.08525 19.2502 8.0478 19.25Z",
    stroke: "#BABFC7",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightBlack);
export default __webpack_public_path__ + "static/media/chevron-right-black.7f6cde60a9a89091c76e62611cf8f8fe.svg";
export { ForwardRef as ReactComponent };